import { makeStyles } from '@mui/styles'

export default makeStyles((theme: any) => ({
    DoubleButton: {
        border: `2px solid ${theme.palette.lightGrey.half}`,
        borderRadius: '1rem',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    DoubleButtonSeparator: {
        width: '2px',
        height: '2rem',
        background: theme.palette.lightGrey.half,
    },
    DoubleButtonButton: {
        flex: 1,
        minWidth: 'fit-content',
    },
}))
